export default __webpack_public_path__ + "locales/lv/RoomLogoCover.json?hash=ed039464e1eb77c0e0dac8c01af1c840";